import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { FaPhoneAlt, FaInstagram, FaEnvelope } from "react-icons/fa";
import bg from "images/bg.jpg";
import styled from "styled-components";
import Light from "components/headers/light";

const StyledHero = styled.div`
  background-image: url(${bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #336734; // <-- Add this line
  position: relative;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0px 0 60px 0;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
  }
`;

const HeroTitle = styled.h1`
  color: #336734;
  font-weight: bold;
  font-size: 52px;
  margin: 0;
  position: relative;
  z-index: 2;
`;

const ContactSection = styled.div`
  background-color: #ffffff;
  padding: 80px 0;
`;

const StyledCard = styled(Card)`
  border: none;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); // Subtle shadow for depth
  height: 100%;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-10px); // Lift on hover
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12); // Stronger shadow on hover
  }
`;

const IconWrapper = styled.div`
  background-color: #336734;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const ContactInfo = styled.div`
  text-align: center;
`;

const ContactText = styled.h5`
  color: #555;
  font-weight: normal;
  margin-bottom: 0;
`;

const ContactLink = styled.a`
  text-decoration: none;
  color: #336734; // Use brand color for links
  font-weight: 500;
  &:hover {
    color: #333; // Darker on hover
  }
`;

const Contact = () => {
  return (
    <AnimationRevealPage>
      <Light />
      <StyledHero>
        <HeroTitle>Contactez-Nous</HeroTitle>
      </StyledHero>

      <ContactSection>
        <Container>
          <Row className="g-4 justify-content-center">
            {/* Phone Card */}
            <Col xs={12} md={4}>
              <StyledCard className="p-4">
                <ContactInfo>
                  <IconWrapper>
                    <FaPhoneAlt size={24} color="#ffffff" />
                  </IconWrapper>
                  <ContactText>
                    <ContactLink href="tel:+2126673496838">
                      +212 673496838
                    </ContactLink>
                  </ContactText>
                </ContactInfo>
              </StyledCard>
            </Col>

            {/* Instagram Card */}
            <Col xs={12} md={4}>
              <StyledCard className="p-4">
                <ContactInfo>
                  <IconWrapper>
                    <FaInstagram size={24} color="#ffffff" />
                  </IconWrapper>
                  <ContactText>
                    <ContactLink
                      href="https://www.instagram.com/lanciabio/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
Élancia Bio                    </ContactLink>
                  </ContactText>
                </ContactInfo>
              </StyledCard>
            </Col>

            {/* Email Card */}
            <Col xs={12} md={4}>
              <StyledCard className="p-4">
                <ContactInfo>
                  <IconWrapper>
                    <FaEnvelope size={24} color="#ffffff" />
                  </IconWrapper>
                  <ContactText>
                    <ContactLink href="mailto:malyavita.01@gmail.com">
                      malyavita.01@gmail.com
                    </ContactLink>
                  </ContactText>
                </ContactInfo>
              </StyledCard>
            </Col>
          </Row>
        </Container>
      </ContactSection>

      <Footer />
    </AnimationRevealPage>
  );
};

export default Contact;